import { all, takeEvery, put, call } from 'redux-saga/effects'
import {
  getCPsConflictivos,
  updateCPConflictivo,
  insertCPConflictivo,
} from 'services/logisticaPedido'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_CPS_CONFLICTIVOS() {
  try {
    const cpsConflictivosData = yield call(getCPsConflictivos)
    if (cpsConflictivosData.ok) {
      yield put({
        type: actions.CP_CONFLICTIVO_LOAD_SUCCEEDED,
        payload: cpsConflictivosData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar códigos postales conflictivos')
      put({
        type: actions.CP_CONFLICTIVO_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.CP_CONFLICTIVO_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_CP_CONFLICTIVO(action) {
  try {
    const cpConflictivoObj = yield call(insertCPConflictivo, action.payload)
    if (cpConflictivoObj.ok) {
      putMessage(messageType.SUCCESS, 'Código postal conflictivo creado correctamente')
      yield put({
        type: actions.CP_CONFLICTIVO_INSERT_SUCCEEDED,
        payload: cpConflictivoObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear Código postal conflictivo')
      yield put({
        type: actions.CP_CONFLICTIVO_INSERT_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear Código postal conflictivo')
    yield all([
      put({
        type: actions.CP_CONFLICTIVO_INSERT_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_CP_CONFLICTIVO(action) {
  try {
    const cpConflictivoObj = yield call(updateCPConflictivo, action.payload)
    if (cpConflictivoObj.ok) {
      putMessage(messageType.SUCCESS, 'Código postal conflictivo modificado correctamente')
      yield put({
        type: actions.CP_CONFLICTIVO_UPDATE_SUCCEEDED,
        payload: cpConflictivoObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar Código postal conflictivo')
      yield put({
        type: actions.CP_CONFLICTIVO_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar Código postal conflictivo')
    yield all([
      put({
        type: actions.CP_CONFLICTIVO_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.CP_CONFLICTIVO_LOAD_REQUESTED, GET_CPS_CONFLICTIVOS),
    takeEvery(actions.CP_CONFLICTIVO_INSERT_REQUESTED, INSERT_CP_CONFLICTIVO),
    takeEvery(actions.CP_CONFLICTIVO_UPDATE_REQUESTED, UPDATE_CP_CONFLICTIVO),
  ])
}
